import greenApple from 'routes/vendor/storemanage/images/greenApple.png';
import greenGrape from 'routes/vendor/storemanage/images/greenGrape.png';
import peach from 'routes/vendor/storemanage/images/peach.png';

const generateAutoOrderData = storeNo => {
    const today = new Date(); // 현재 날짜
    const oneWeekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000); // 현재 날짜에서 1주일 전의 날짜

    const testAutoOrderData = [];

    // 10건의 데이터를 생성하여 testAutoOrderData에 추가
    for (let i = 1; i <= 10; i++) {
        const randomTime =
            oneWeekAgo.getTime() +
            Math.random() * (today.getTime() - oneWeekAgo.getTime());
        const randomDate = new Date(randomTime);

        const newOrder = {
            storeId: storeNo,
            storeOrderId: `A20240327-${i}`,
            storeOrderName: '주문자',
            storeOrderDate: randomDate
                .toISOString()
                .slice(0, 19)
                .replace('T', ' '), // YYYY-MM-DD HH:MM:SS 형식으로 변환
            storeOrderItemName: '청사과 먹구싶오',
            storeOrderItemCnt: Math.floor(Math.random() * 50) + 1,
            storeOrderPrice: Math.floor(Math.random() * 50000) + 10000,
            storeOrderImg: [greenApple, greenGrape, peach],
        };
        testAutoOrderData.push(newOrder);
    }

    // 생성된 데이터를 최신 날짜 기준으로 내림차순 정렬
    testAutoOrderData.sort(
        (a, b) => new Date(b.storeOrderDate) - new Date(a.storeOrderDate),
    );

    return testAutoOrderData;
};

export default generateAutoOrderData;
